import { IDecisionPreview } from 'ApiPackage/SearchModule/interfaces/IDecisionPreview';
import { parseErknmValue } from 'PassportKnmPackage/MainModule/common/parseErknmValue';

import styles from '../styles.module.scss';
import { KnmSubtitle } from '../KnmSubtitle';

interface IDecisionControlProps {
  passportData?: IDecisionPreview;
}

export const DecisionControl = ({ passportData }: IDecisionControlProps) => {
  const kindControl = parseErknmValue<{ title?: string; number?: string }>(passportData?.kindControl.value || '');

  return (
    <div className={styles.ColumnContent}>
      <KnmSubtitle title="Контрольный (надзорный) орган">
        <div className={styles.Row}>
          <div className={styles.ColText}>Наименование органа контроля</div>
          <div className={styles.ColValue}>
            {parseErknmValue<{ fullName?: string }>(passportData?.knoOrganization.value || '')?.fullName}
          </div>
        </div>
        <div className={styles.Row}>
          <div className={styles.ColText}>Вид контроля (надзора) и его номер</div>
          <div className={styles.ColValue}>
            {kindControl?.number} - {kindControl?.title}
          </div>
        </div>
      </KnmSubtitle>
    </div>
  );
};
